<template>
  <div v-cloak id="printBox" ref="box">
    <div class="shoppingCart">
      <div class="shoppingCart_head">
        <div class="cartTitle">
          <p>我的购物车</p>
          <div class="allGoods">全部商品({{ cartNumber }})</div>
        </div>
        <div style="display:flex;margin-top: 34px">
          <div style="margin-left:30px">
            <el-input
              placeholder="请输入款号"
              prefix-icon="el-icon-search"
              v-model="listQuery.styleNumber"
              @keyup.enter.native="getsearchCart()"
              clearable
            ></el-input>
          </div>
          <div class="searchClass" @click="getsearchCart()">搜索</div>
        </div>
      </div>
      <div v-if="shoppingCart.length > 0" ref="barWrap">
        <div v-for="(item, index) in shoppingCart" :key="index">
          <!-- 素金定单 -->
          <CartPlainGoldCustom
            ref="cartCustom"
            @updataCart="updataCart"
            :addOrderList="addOrderList"
            :cycleCustom="item"
          />
        </div>
      </div>
      <div
        v-if="shoppingCart.length == 0"
        style="text-align:center;margin:60px 0"
      >
        <img src="@/assets/img/noData.png" alt />
      </div>
      <div
        :class="navBarFixed == true ? 'cartNavBarWrap' : 'navBarNo'"
        ref="navBar"
      >
        <div class="selectBox">
          <div class="selectBox_left">
            <div class="selectAll">
              <el-checkbox v-model="spotData" @change="spotAll"></el-checkbox>
            </div>
            <div class="selectText">现货全选</div>
          </div>
          <div class="selectBox_left" v-if="hasMainBodyType()[0].value !== '2'">
            <div class="selectAll">
              <el-checkbox
                v-model="customData"
                @change="customAll"
              ></el-checkbox>
            </div>
            <div class="selectText">定单全选</div>
          </div>
        </div>
        <div class="modifyBox">
          <div class="modifyBox_left">
            <div class="selectAll">
              <el-checkbox
                v-model="checkedData"
                @change="ZlfAllproducts"
              ></el-checkbox>
            </div>
            <div class="ckeckAll">全选</div>
            <div class="deleteAll" @click="showdetailbox">
              删除
            </div>
          </div>
          <div class="modifyBox_right">
            <div v-if="comOrganization.status === 'O'">
              <div class="selectedNumber">
                已选<span class="selectedInterval">{{ shangp }}</span
                >件商品
              </div>
              <div class="selectedNumber">
                (现货
                <div class="selectedInterval">{{ spotNumber }}</div>
                件<span v-if="hasMainBodyType()[0].value !== '2'"
                  >,定单
                  <span class="selectedInterval">{{ comtosNumber }}</span>
                  <span>件</span> </span
                >)
              </div>
              <div class="selectedNumber" v-if="totalGoldWeight">
                现货素金总金重:
                <div class="selectedInterval">{{ totalGoldWeight }}g</div>
              </div>
              <div class="submitOrder" @click="submitOrder">
                提&nbsp;&nbsp;交
              </div>
            </div>

            <div
              v-else-if="comOrganization.status === 'S'"
              style="width: 100%; line-height: 36px; text-align: right; color: red"
            >
              该网点已停运，无法加入购物车
            </div>
            <div
              v-else-if="comOrganization.status === 'F'"
              style="width: 100%; line-height: 36px; text-align: right; color: red"
            >
              该网点已冻结，无法加入购物车
            </div>
          </div>
        </div>
      </div>
    </div>
    <SubmitDialog
      v-if="submitDialogVisible"
      :submitDialogVisible="submitDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @placeOrder="placeOrder"
    />
    <!-- 删除确认弹窗 -->
    <ConfirmDeletion
      v-if="deletingPopoversVisible"
      :deletingPopoversVisible="deletingPopoversVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @confirmDel="confirmDel"
    />
  </div>
</template>

<script>
import { Decimal } from 'decimal.js'
import { cartListData, modifyCartPublic, pushOrder } from '@/api/cartApi'
import CartPlainGoldCustom from './components/custom/CartPlainGoldCustom.vue'
import SubmitDialog from './components/submit/SubmitDialog.vue'
import ConfirmDeletion from './components/updata/ConfirmDeletion.vue'
import { deepClone } from '@/utils/util'
import store from '@/store'
import ls from '@/utils/localStorage'

export default {
  components: {
    CartPlainGoldCustom,
    SubmitDialog,
    ConfirmDeletion,
  },
  data() {
    return {
      noOrders: false,
      submitDialogVisible: false,
      deletingPopoversVisible: false,
      shoppingCart: [],
      addOrderList: [],
      idList: [],
      navBarFixed: false,
      listCode: [], //现货售完
      customMadeCode: [], //定单售完
      listQuery: {
        size: 9999,
        current: 1,
        styleNumber: '',
      },
      comOrganization: ls.get('comOrganization'),
    }
  },
  computed: {
    // 所有全选
    checkedData: {
      get() {
        let copyList = []
        this.shoppingCart.forEach((res, index) => {
          if (res.length > 0) {
            res.forEach((item, i) => {
              item.cartList.forEach((ele) => {
                if (ele.shopType === '2' && ele.type == 2) {
                  if (ele.quantity >= 5 && res.customStock != true) {
                    copyList.push(ele)
                  }
                } else if (ele.cartStatus === '现货') {
                  copyList.push(ele)
                }
              })
            })
          }
        })
        if (copyList.length != 0) {
          return copyList.every((val) => {
            return val.switchFlag === true
          })
        }
      },
      set() {
        let copyList = []
        this.shoppingCart.forEach((res, index) => {
          if (res.length > 0) {
            res.forEach((item, i) => {
              item.cartList.forEach((ele) => {
                if (ele.shopType === '2' && ele.type == 2) {
                  if (ele.quantity >= 5 && res.customStock != true) {
                    copyList.push(ele)
                  }
                } else if (ele.cartStatus === '现货') {
                  copyList.push(ele)
                }
              })
            })
          }
        })
        if (copyList.length != 0) {
          return copyList.every((val) => {
            return val.switchFlag === true
          })
        }
      },
    },
    // 现货全选
    spotData: {
      get() {
        let spot = []
        this.shoppingCart.forEach((res) => {
          res.forEach((item) => {
            item.cartList.forEach((ele) => {
              if (ele.type == 1 && ele.cartStatus === '现货') {
                spot.push(ele)
              }
            })
          })
        })
        if (spot.length != 0) {
          return spot.every((val) => {
            return val.switchFlag === true
          })
        }
      },
      set() {
        let spot = []
        this.shoppingCart.forEach((res) => {
          res.forEach((item) => {
            item.cartList.forEach((ele) => {
              if (ele.type == 1 && ele.cartStatus === '现货') {
                spot.push(ele)
              }
            })
          })
        })
        if (spot.length != 0) {
          return spot.every((val) => {
            return val.switchFlag === true
          })
        }
      },
    },
    // 定单全选
    customData: {
      get() {
        let copyList = []
        this.shoppingCart.forEach((res, index) => {
          res.forEach((item, i) => {
            item.cartList.forEach((ele) => {
              if (ele.shopType == 2) {
                if (
                  ele.type == 2 &&
                  ele.quantity >= 5 &&
                  res.customStock != true
                ) {
                  copyList.push(ele)
                }
              } else if (ele.type == 2 && ele.cartStatus === '现货') {
                copyList.push(ele)
              }
            })
          })
        })
        if (copyList.length != 0) {
          return copyList.every((val) => {
            return val.switchFlag === true
          })
        }
      },
      set() {
        let copyList = []
        this.shoppingCart.forEach((res, index) => {
          res.forEach((item, i) => {
            item.cartList.forEach((ele) => {
              if (ele.shopType == 2) {
                if (
                  ele.type == 2 &&
                  ele.quantity >= 5 &&
                  res.customStock != true
                ) {
                  copyList.push(ele)
                }
              } else if (ele.type == 2 && ele.cartStatus === '现货') {
                copyList.push(ele)
              }
            })
          })
        })
        if (copyList.length != 0) {
          return copyList.every((val) => {
            return val.switchFlag === true
          })
        }
      },
    },
    // 全部商品
    cartNumber: function() {
      let shangp = 0
      this.shoppingCart.forEach((element) => {
        element.forEach((item) => {
          item.cartList.forEach((res) => {
            shangp += Number(res.quantity)
          })
        })
      })
      return shangp
    },
    // 总商品数量
    shangp: function() {
      let shangp = 0
      this.shoppingCart.forEach((element) => {
        element.forEach((item) => {
          item.cartList.forEach((res) => {
            if (res.switchFlag === true) {
              shangp += Number(res.quantity)
            }
          })
        })
      })
      return shangp
    },
    // 现货商品数量
    spotNumber: function() {
      let spotNumber = 0
      this.shoppingCart.forEach((element) => {
        element.forEach((item) => {
          item.cartList.forEach((res) => {
            if (
              res.switchFlag === true &&
              ['潮流爆款'].includes(res.productRemark)
            ) {
              spotNumber += Number(res.quantity)
            }
          })
        })
      })
      return spotNumber
    },
    //预定商品数量
    comtosNumber: function() {
      let comtosNumber = 0
      this.shoppingCart.forEach((element) => {
        element.forEach((item) => {
          item.cartList.forEach((res) => {
            if (
              res.switchFlag === true &&
              !['潮流爆款'].includes(res.productRemark)
            ) {
              comtosNumber += Number(res.quantity)
            }
          })
        })
      })
      return comtosNumber
    },
    // 购物车批发总金额
    wholesalePrice: function() {
      var money = 0
      this.shoppingCart.map((val) => {
        val.map((res) => {
          res.cartList.forEach((ele) => {
            if (ele.switchFlag === true && ele.tradePrice) {
              money = new Decimal(money).add(new Decimal(ele.tradePrice))
            }
          })
          return res
        })
      })
      return money
    },
    // 购物车标签总金额
    shopCarPrice: function() {
      var money = 0
      this.shoppingCart.map((val) => {
        val.map((res) => {
          res.cartList.forEach((ele) => {
            if (ele.switchFlag === true && ele.labelPrice) {
              money = new Decimal(money).add(new Decimal(ele.labelPrice))
            }
          })
          return res
        })
      })
      return money
    },
    // 购物车素金现货总金重
    totalGoldWeight: function() {
      var goldWeight = 0
      this.shoppingCart.map((val) => {
        val.map((res) => {
          res.cartList.forEach((ele) => {
            if (
              ele.switchFlag === true &&
              ele.shopType === '2' &&
              ele.type === 1
            ) {
              goldWeight = new Decimal(goldWeight).add(
                new Decimal(ele.goldWeigh)
              )
            }
          })
          return res
        })
      })
      return goldWeight
    },
  },
  mounted() {
    // 购物车查看
    this.getList()
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  methods: {
    // 关闭弹窗
    onCloseSelectDialog() {
      this.deletingPopoversVisible = false
      this.submitDialogVisible = false
      this.listQuery.current = 1
      this.getList()
    },
    updataCart() {
      this.listQuery.current = 1
      this.getList()
    },
    // 获取列表数据
    getList() {
      console.log(this.listQuery)
      cartListData(this.listQuery).then((res) => {
        this.shoppingCart = []
        this.addOrderList = deepClone(res.data.records)
        res.data.records.forEach((item) => {
          item.flag = false
          item.customStock = false
          let labelPrice = 0
          let tradePrice = 0
          let quantity = 0
          let goldWeigh = 0
          item.forEach((ele, index) => {
            // 现货只展示一条，相加所有现货价格到第一条
            ele.cartList.forEach((add, index) => {
              add.materialFlag = false
              // 其他现货
              if (
                ele.type === 1 &&
                ele.cartList.length > 1 &&
                ele.shopType !== '1'
              ) {
                labelPrice = Number(labelPrice) + Number(add.labelPrice)
                tradePrice = Number(tradePrice) + Number(add.tradePrice)
                quantity = Number(quantity) + Number(add.quantity)
                ele.cartList[0].labelPrice = labelPrice
                ele.cartList[0].tradePrice = tradePrice
                ele.cartList[0].quantity = quantity
                // 钻石单独款
              } else if (
                ele.type === 1 &&
                ele.cartList.length > 1 &&
                ele.shopType === '1' &&
                ele.product.isCouples === '2'
              ) {
                labelPrice = Number(labelPrice) + Number(add.labelPrice)
                tradePrice = Number(tradePrice) + Number(add.tradePrice)
                quantity = Number(quantity) + Number(add.quantity)
                ele.cartList[0].labelPrice = labelPrice
                ele.cartList[0].tradePrice = tradePrice
                ele.cartList[0].quantity = quantity
              }
              if (
                ele.type === 1 &&
                ele.cartList.length > 1 &&
                ele.shopType === '2' &&
                add.goldWeigh
              ) {
                goldWeigh = new Decimal(goldWeigh).add(
                  new Decimal(add.goldWeigh)
                )
                ele.cartList[0].goldWeigh = goldWeigh
              }
            })
            // 如果是现货，只保留第一个数据
            if (
              ele.type === 1 &&
              ele.cartList.length > 1 &&
              ele.shopType !== '1'
            ) {
              var i = ele.cartList.length
              while (i--) {
                if (ele.cartList.length > 1) {
                  ele.cartList.splice(i, 1)
                }
              }
            } else if (
              ele.type === 1 &&
              ele.cartList.length > 1 &&
              ele.shopType === '1' &&
              ele.product.isCouples === '2'
            ) {
              var i = ele.cartList.length
              while (i--) {
                if (ele.cartList.length > 1) {
                  ele.cartList.splice(i, 1)
                }
              }
            } else if (
              ele.type === 1 &&
              ele.cartList.length > 1 &&
              ele.shopType === '1' &&
              ele.product.isCouples === '1'
            ) {
              // 钻石情侣戒
              ele.cartList = this.process(ele.cartList)
            }
            ele.cartList.forEach((arrly) => {
              if (ele.cartStatus == '下架' || ele.cartStatus == '已售') {
                item.customStock = true
              }
              arrly.switchFlag = false
            })
          })
          this.shoppingCart.push(item)
        })
        // 数据更新完成之后
        this.$nextTick(() => {
          if (
            this.$refs.barWrap?.getBoundingClientRect().bottom >
            document.documentElement.clientHeight
          ) {
            this.navBarFixed = true
          }
        })
      })
    },
    // 钻石情侣戒去重
    process(arr) {
      // 缓存用于记录
      const cache = []
      for (const t of arr) {
        // 检查缓存中是否已经存在
        if (
          cache.find(
            (c) => c.texture === t.texture && c.genderCode === t.genderCode
          )
        ) {
          cache.find(
            (c) => c.texture === t.texture && c.genderCode === t.genderCode
          ).quantity =
            Number(
              cache.find(
                (c) => c.texture === t.texture && c.genderCode === t.genderCode
              ).quantity
            ) + Number(t.quantity)
          cache.find(
            (c) => c.texture === t.texture && c.genderCode === t.genderCode
          ).labelPrice =
            Number(
              cache.find(
                (c) => c.texture === t.texture && c.genderCode === t.genderCode
              ).labelPrice
            ) + Number(t.labelPrice)
          cache.find(
            (c) => c.texture === t.texture && c.genderCode === t.genderCode
          ).tradePrice =
            Number(
              cache.find(
                (c) => c.texture === t.texture && c.genderCode === t.genderCode
              ).tradePrice
            ) + Number(t.tradePrice)
          // 已经存在说明以前记录过，现在这个就是多余的，直接忽略掉
          continue
        }
        // 不存在就说明以前没遇到过，把它记录下来
        cache.push(t)
      }
      // 记录结果就是过滤后的结果
      return cache
    },
    watchScroll() {
      if (
        this.$refs.barWrap?.getBoundingClientRect().bottom >
        document.documentElement.clientHeight
      ) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    // 购物车搜索
    getsearchCart() {
      this.listQuery.current = 1
      this.getList()
    },
    // 鼠标移出
    imgLeave() {
      this.shutDown()
    },
    // 确认删除
    confirmDel() {
      let delList = []
      this.idList.forEach((res) => {
        let obj = {
          id: res.id,
          sequences: [res.sequence],
        }
        delList.push(obj)
      })
      modifyCartPublic(delList, 'delete').then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 1500,
          })
          this.deletingPopoversVisible = false
          this.listQuery.current = 1
          this.getList()
        }
      })
    },
    // 购物车删除按钮
    showdetailbox() {
      this.idList = []
      let idS = []
      this.shoppingCart.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            if (ele.switchFlag) {
              if (!idS.includes(ele)) {
                idS.push(ele)
              }
            }
          })
        })
      })
      this.addOrderList.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            idS.forEach((ally) => {
              // 钻石现货
              if (ally.shopType === '1' && ally.type === 1 && ally.genderCode) {
                if (
                  ele.id === ally.id &&
                  ele.texture === ally.texture &&
                  ele.genderCode === ally.genderCode
                ) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              } else if (ally.type === 1) {
                if (ele.id === ally.id) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              } else {
                if (ele.id === ally.id && ele.sequence === ally.sequence) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              }
            })
          })
        })
      })
      if (this.idList.length <= 0) {
        this.$message({
          message: '至少选择一条商品删除',
          type: 'warning',
          duration: 1500,
        })
      } else {
        this.deletingPopoversVisible = true
      }
    },
    // 确定下单
    placeOrder(from) {
      let orderInfor = deepClone(from)
      delete orderInfor.organizationList
      orderInfor.cartRequestDtoList = []
      // 修改bug
      // if (orderInfor.netAddress?.indexOf('-') > 0) {
      //   orderInfor.netCode = from.netAddress.split('-')[0]
      //   orderInfor.netAddress = from.netAddress.split('-')[1]
      // }
      this.idList.forEach((res) => {
        let obj = {
          id: res.id,
          sequences: [res.sequence],
        }
        orderInfor.cartRequestDtoList.push(obj)
      })
      pushOrder(orderInfor)
        .then((res) => {
          if (res.code === 0) {
            this.submitDialogVisible = false
            this.$confirm(
              '尊敬的客户，您的订单已初步生成，请联系订单页面对应的手机号，为您提供后续服务。',
              '订单提交成功',
              {
                confirmButtonText: '继续下单',
                cancelButtonText: '查看订单',
                type: 'success',
              }
            )
              .then(() => {
                this.getList()
                this.idList = []
              })
              .catch(() => {
                this.idList = []
                this.$router.push('/CommodityOrder')
              })
          }
        })
        .catch((err) => {
          if (err === '存在已售或下架商品') {
            this.submitDialogVisible = false
            this.getList()
          }
        })
    },
    // 购物车下单按钮
    submitOrder() {
      this.idList = []
      let idS = []
      this.shoppingCart.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            if (ele.switchFlag) {
              if (!idS.includes(ele)) {
                idS.push(ele)
              }
            }
          })
        })
      })
      this.addOrderList.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            idS.forEach((ally) => {
              // 钻石现货
              if (ally.shopType === '1' && ally.type === 1 && ally.genderCode) {
                if (
                  ele.id === ally.id &&
                  ele.texture === ally.texture &&
                  ele.genderCode === ally.genderCode
                ) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              } else if (ally.type === 1) {
                if (ele.id === ally.id) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              } else {
                if (ele.id === ally.id && ele.sequence === ally.sequence) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele)
                  }
                }
              }
            })
          })
        })
      })
      if (this.idList.length <= 0) {
        this.$message({
          message: '至少选择一条商品下单',
          type: 'warning',
          duration: 1500,
        })
      } else {
        this.submitDialogVisible = true
      }
    },
    // 商品全选
    ZlfAllproducts(e) {
      if (e) {
        this.$refs.cartCustom.forEach((res) => {
          res.cycleCustom.flag = true
          res.onChange(e)
        })
      } else {
        this.$refs.cartCustom.forEach((res) => {
          res.cycleCustom.flag = false
          res.onChange(e)
        })
      }
      this.$forceUpdate()
    },
    // 现货全选
    spotAll(e) {
      if (e) {
        this.shoppingCart = this.shoppingCart.map((val, index) => {
          val.map((res, idx) => {
            res.cartList.forEach((ele, i) => {
              if (['潮流爆款'].includes(ele.productRemark)) {
                ele.switchFlag = true
              } else {
                ele.switchFlag = false
              }
              val.flag = res.cartList.every((val) => val.switchFlag == true)
            })
          })
          return val
        })
      } else {
        this.shoppingCart = this.shoppingCart.map((val, index) => {
          val.map((res, idx) => {
            res.cartList.forEach((ele, i) => {
              if (['潮流爆款'].includes(ele.productRemark)) {
                ele.switchFlag = false
                val.flag = false
              }
            })
          })
          return val
        })
      }
      this.$forceUpdate()
    },
    // 定单全选
    customAll(e) {
      if (e) {
        this.$refs.cartCustom.forEach((res) => {
          if (res.cycleCustom[0]?.type === 2) {
            res.cycleCustom.flag = true
            res.onChange(e)
          }
        })
      } else {
        this.$refs.cartCustom.forEach((res) => {
          if (res.cycleCustom[0]?.type === 2) {
            res.cycleCustom.flag = false
            res.onChange(e)
          }
        })
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchScroll)
  },
}
</script>
<style lang="scss" scoped>
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  cursor: not-allowed !important;
  background-image: none !important;
  border: none !important;
  background: #c8c9cc !important;
  color: #fff !important;
}

.mainStoneSizeClass {
  width: 78px !important;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-right: 1px solid #ec9368;
}

#printBox {
  background: #f3f3f3;
}

.shoppingCart_head .el-input {
  display: block;
}

.shoppingCart_head ::v-deep .el-input__inner {
  border: 1px solid #ec9368;
  border-radius: 20px !important;
}

.shoppingCart {
  max-width: 1500px;
  margin: 0 auto;
  min-height: 880px;
  background: #fff;

  .shoppingCart_head {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
  }

  .shoppingCart_bodyFather {
    border: 1px solid #ede2ce;
    margin-top: 12px;

    .activeBack {
      background: red;
    }

    .shoppingCart_body {
      width: 100%;
      min-height: 105px;
      display: flex;
      font-size: 0;
      position: relative;

      .shoppingCart_body_child {
        display: flex;
        align-items: center;
        position: relative;

        img {
          width: 70px;
          height: 70px;
          cursor: pointer;
        }
      }

      .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 24px 0;
      }
    }
  }

  .selectBox {
    display: flex;
    align-items: center;
    margin: 30px 0 10px 0;

    .selectBox_left {
      display: flex;
      align-items: center;

      .selectText {
        color: #000000;
        margin-right: 40px;
        font-size: 20px;
      }
    }

    ::v-deep .el-checkbox__input {
      vertical-align: inherit;
    }

    ::v-deep .el-checkbox__inner {
      width: 16px !important;
      height: 16px !important;
    }

    ::v-deep .el-checkbox__inner::after {
      height: 9px !important;
      left: 5px !important;
      top: 0px !important;
      width: 3px !important;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #ec9368;
      border-color: #ec9368;
    }

    ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6 !important;
    }

    ::v-deep .el-checkbox__inner:hover {
      border-color: #ec9368 !important;
    }

    ::v-deep .el-checkbox__inner:focus {
      border-color: #ec9368 !important;
    }
  }

  .selectAll {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .modifyBox {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modifyBox_left {
      display: flex;
      // font-size: 24px;
      align-items: center;
      height: 66px;

      ::v-deep .el-checkbox__input {
        vertical-align: inherit;
      }

      ::v-deep .el-checkbox__inner {
        width: 16px !important;
        height: 16px !important;
      }

      ::v-deep .el-checkbox__inner::after {
        height: 9px !important;
        left: 5px !important;
        top: 0px !important;
        width: 3px !important;
      }

      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ec9368;
        border-color: #ec9368;
      }

      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6 !important;
      }

      ::v-deep .el-checkbox__inner:hover {
        border-color: #ec9368 !important;
      }

      ::v-deep .el-checkbox__inner:focus {
        border-color: #ec9368 !important;
      }

      .ckeckAll {
        color: #000000;
        margin-right: 40px;
        font-size: 24px;
      }

      .deleteAll {
        color: #ff0000;
        font-size: 24px;
        cursor: pointer;
        z-index: 1;
      }
    }

    .modifyBox_right {
      display: flex;
      font-size: 16px;
      align-items: center;
    }

    .selectedNumber {
      display: flex;
      margin-right: 15px;
      align-items: baseline;
    }

    .selectedInterval {
      color: #ec9368;
      margin: 0 5px;
    }

    .submitOrder {
      color: #fff;
      width: 140px;
      height: 66px;
      text-align: center;
      line-height: 66px;
      background: #ec9368;
      cursor: pointer;
    }
  }
}

.el-select-dropdown__item {
  width: 97%;
}
</style>

<style scoped>
.shoppingCart_head .el-input__inner {
  height: 33px !important;
  line-height: 33px !important;
}

.cartTitle {
  font-size: 24px;
  color: #000;
  margin-top: 34px;
  display: flex;
  align-items: center;
}

.allGoods {
  font-size: 22px;
  color: #ec9368;
  margin-left: 10px;
}

.cartNavBarWrap {
  position: fixed;
  bottom: 0;
  left: 50%;
  padding-bottom: 20px;
  transform: translate(-50%, 0);
  z-index: 999;
  background: #fff;
  width: 100%;
  max-width: 1480px;
  padding: 10px;
}

.navBarNo {
  max-width: 1480px;
  width: 100%;
  background: #fff;
  padding: 10px;
}

.bottomBox .el-button--primary {
  background: #ec9368 !important;
  border-color: #ec9368 !important;
}

.bottomBox .el-button--primary:focus {
  border: none !important;
}

.bottomBox {
  width: 380px;
  border: 1px solid #ec9368;
  margin: 0 auto;
}

.bottomBox .el-button--primary:hover {
  width: 380px !important;
  border-radius: 0;
}

.el-button {
  border-radius: 0 !important;
}

.searchClass {
  height: 40px;
  line-height: 40px;
  background: #ec9368;
  color: #fff;
  width: 60px;
  text-align: center;
  font-size: 16px;
  border-radius: 30px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
